// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bj8k","footer":"styles_footer__13Jur","passCodeTooltip":"styles_passCodeTooltip__3HxRE"};